const getMonthName = (monthAndYear: number): string => {
  const monthNames = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];
  const month = monthAndYear % 100;
  return `${monthNames[month - 1] || ""} de ${monthAndYear.toString().substring(0, 4)}`;
};

export default getMonthName;
